﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { Polygon, MultiPolygon, LineString, MultiLineString, Point, MultiPoint, GeometryCollection } from 'ol/geom.js';
import { defaults as defaultInteractions, Draw, Modify, DragBox, Select, Snap } from 'ol/interaction.js';
import { click } from 'ol/events/condition.js';
import TileWMSSource from 'ol/source/TileWMS.js';
import ImageWMSSource from 'ol/source/ImageWMS.js';
import ImageSource from 'ol/source/Image.js';
import TileLayer from 'ol/layer/Tile.js';
import ImageLayer from 'ol/layer/Image.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import { Utility } from '../Utility.js';
export { NetworkBudgetTool };

/**
 * Class Network Budget tool
 */
const NetworkBudgetTool = function ()
{
    // Define this
    var myNetworkBudgetTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Indicate what button is active
    this._buttonActive = null;

    // Layer draw pipe
    this._layerDrawPipe = null;

    // Interaction draw pipe
    this._drawPipe = null;

    // Interaction modify pipe
    this._modifyDrawPipe = null;

    // Style draw pipe
    this._styleDrawPipe = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.8)',
                width: 3
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 1)',
                width: 2
            })
        }),
        new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.8)'
            }),
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 1)',
                //lineDash: [10, 10],
                width: 1
            }),
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 0.7)'
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                })
            })
        })
    ];

    // Layer draw manhole
    this._layerDrawManhole = null;

    // Interaction draw manhole
    this._drawManhole = null;

    // Interaction modify manhole
    this._modifyDrawManhole = null;

    // Style draw manhole
    this._styleDrawManhole = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.8)',
                width: 3
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 1)',
                width: 2
            })
        }),
        new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.8)'
            }),
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 1)',
                //lineDash: [10, 10],
                width: 1
            }),
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 0.7)'
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                })
            })
        })
    ];

    // Select element
    this._selectElement = null;

    // Style for element selected
    this._selectElementStyle = [
        new Style({
            image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 0.5)',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 10
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.5)'
            })
        })
    ];

    // Id feature generator
    this._idFeatureGenerator = 1;

    // Get network buget info
    this._networkBugdetInfo = {
        pipe: {},
        manhole: {}
    };

    // Info reference
    this._referenceInfo = {};

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------
    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Menu definition
     */
    this.BuildMenuBar = function ()
    {
        // -- Select edge -------------------------------------------------------------------------
        const buttonSelect = document.createElement('li');
        buttonSelect.className = "border-right";

        const buttonSelectContainer = document.createElement('a');
        buttonSelectContainer.setAttribute('href', '#id-target-gpi-nb-select-element');
        buttonSelectContainer.id = 'id-target-gpi-nb-select-element';
        buttonSelectContainer.className = 'target';
        buttonSelectContainer.setAttribute('title', 'Selecionar');

        const buttonSelectContent = document.createElement('div');
        buttonSelectContent.className = 'menu-icon';
        buttonSelectContent.innerHTML = '<i class="gpi gpi-selecionar"></i>';

        buttonSelectContainer.appendChild(buttonSelectContent);
        buttonSelect.appendChild(buttonSelectContainer);

        /**
         * Select Handle
         */
        const handleSelect = function () {
            if(myNetworkBudgetTool._buttonActive !== null && myNetworkBudgetTool._buttonActive !== "buttonSelect")
                return;

            myNetworkBudgetTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-select-element');

            if (!$(this).find('a').hasClass('hold-button')) { // Reset select

                // Active event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.on('singleclick', async (e) => { await myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips(e); });

                // Desactice interraction draw pipe modify
                myNetworkBudgetTool._modifyDrawPipe.setActive(false);

                // Desactice interraction draw manhole modify
                myNetworkBudgetTool._modifyDrawManhole.setActive(false);

                // Reset cursor
                document.body.style.cursor = 'default';

                // Free active button
                myNetworkBudgetTool._buttonActive = null;
            }
            else { // Active select
                // Remove event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.un('singleclick', myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips);

                // Actice interraction draw pipe modify
                myNetworkBudgetTool._modifyDrawPipe.setActive(true);

                // Actice interraction draw manhole modify
                myNetworkBudgetTool._modifyDrawManhole.setActive(true);

                // Change cursor
                document.body.style.cursor = 'pointer';

                // Get active button
                myNetworkBudgetTool._buttonActive = "buttonSelect";
            }
        };

        buttonSelect.addEventListener('click', handleSelect, false);
        buttonSelect.addEventListener('touchstart', handleSelect, false);

        // -- Draw pipe ---------------------------------------------------------------------------
        const buttonDrawPipe = document.createElement('li');

        const buttonDrawPipeContainer = document.createElement('a');
        buttonDrawPipeContainer.setAttribute('href', '#id-target-gpi-nb-draw-pipe');
        buttonDrawPipeContainer.id = 'id-target-gpi-nb-draw-pipe';
        buttonDrawPipeContainer.className = 'target';
        buttonDrawPipeContainer.setAttribute('title', 'Desenhar colector');

        const buttonDrawPipeContent = document.createElement('div');
        buttonDrawPipeContent.className = 'menu-icon';
        buttonDrawPipeContent.innerHTML = '<i class="gpi gpi-linha"></i>';

        buttonDrawPipeContainer.appendChild(buttonDrawPipeContent);
        buttonDrawPipe.appendChild(buttonDrawPipeContainer);

        /**
         * Select Handle
         */
        const handleDrawPipe = function ()
        {
            if(myNetworkBudgetTool._buttonActive !== null && myNetworkBudgetTool._buttonActive !== "buttonDrawPipe")
                return;
            
            myNetworkBudgetTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-draw-pipe');

            if (!$(this).find('a').hasClass('hold-button')) { // Reset select

                // Desactive draw
                myNetworkBudgetTool._drawPipe.setActive(false);

                // Active event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.on('singleclick', async (e) => { await myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips(e); });

                // Reset cursor
                document.body.style.cursor = 'default';

                // Free active button
                myNetworkBudgetTool._buttonActive = null;
            }
            else { // Active select
                // Remove event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.un('singleclick', myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips);

                // Active draw
                myNetworkBudgetTool._drawPipe.setActive(true);

                // Change cursor
                document.body.style.cursor = 'pointer';

                // Get active button
                myNetworkBudgetTool._buttonActive = "buttonDrawPipe";
            }
        };

        buttonDrawPipe.addEventListener('click', handleDrawPipe, false);
        buttonDrawPipe.addEventListener('touchstart', handleDrawPipe, false);

        // -- Draw manhole ------------------------------------------------------------------------
        const buttonDrawManhole = document.createElement('li');

        const buttonDrawManholeContainer = document.createElement('a');
        buttonDrawManholeContainer.setAttribute('href', '#id-target-gpi-nb-draw-manhole');
        buttonDrawManholeContainer.id = 'id-target-gpi-nb-draw-manhole';
        buttonDrawManholeContainer.className = 'target';
        buttonDrawManholeContainer.setAttribute('title', 'Desenhar caixa');

        const buttonDrawManholeContent = document.createElement('div');
        buttonDrawManholeContent.className = 'menu-icon';
        buttonDrawManholeContent.innerHTML = '<i class="gpi gpi-ponto"></i>';

        buttonDrawManholeContainer.appendChild(buttonDrawManholeContent);
        buttonDrawManhole.appendChild(buttonDrawManholeContainer);

        /**
         * Select Handle
         */
        const handleDrawManhole = function ()
        {
            if(myNetworkBudgetTool._buttonActive !== null && myNetworkBudgetTool._buttonActive !== "buttonDrawManhole")
                return;
            
            myNetworkBudgetTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-draw-manhole');

            if (!$(this).find('a').hasClass('hold-button')) { // Reset select

                // Desactive draw
                myNetworkBudgetTool._drawManhole.setActive(false);

                // Active event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.on('singleclick', async (e) => { await myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips(e); });

                // Reset cursor
                document.body.style.cursor = 'default';

                // Free active button
                myNetworkBudgetTool._buttonActive = null;
            }
            else { // Active select
                // Remove event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.un('singleclick', myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips);

                // Active draw
                myNetworkBudgetTool._drawManhole.setActive(true);

                // Change cursor
                document.body.style.cursor = 'pointer';

                // Get active button
                myNetworkBudgetTool._buttonActive = "buttonDrawManhole";
            }
        };

        buttonDrawManhole.addEventListener('click', handleDrawManhole, false);
        buttonDrawManhole.addEventListener('touchstart', handleDrawManhole, false);

        // -- Clean ---------------------------------------------------------------------------
        const buttonClean = document.createElement('li');
        buttonClean.className = "border-left";

        const buttonCleanContainer = document.createElement('a');
        buttonCleanContainer.setAttribute('title', 'Remover selecção');

        const buttonCleanContent = document.createElement('div');
        buttonCleanContent.className = 'menu-icon refresh';
        buttonCleanContent.innerHTML = '<i class="gpi gpi-apagar"></i>';

        buttonCleanContainer.appendChild(buttonCleanContent);
        buttonClean.appendChild(buttonCleanContainer);

        /**
         * Clean handle
         */
        const handleClean = function ()
        {
            // Clean all Budget object
            myNetworkBudgetTool._CleanBudget(true);
        };

        buttonClean.addEventListener('click', handleClean, false);
        buttonClean.addEventListener('touchstart', handleClean, false);

        // -- Snapping ----------------------------------------------------------------------------------
        const buttonSnapping = document.createElement('li');

        const buttonSnappingContainer = document.createElement('a');
        buttonSnappingContainer.setAttribute('href', '#id-target-gpi-nb-snapping');
        buttonSnappingContainer.id = 'id-target-gpi-nb-snapping';
        buttonSnappingContainer.className = 'target';
        buttonSnappingContainer.setAttribute('title', 'Snapping');

        const buttonSnappingContent = document.createElement('div');
        buttonSnappingContent.className = 'menu-icon';
        buttonSnappingContent.innerHTML = '<i class="gpi gpi-snapping"></i>';

        buttonSnappingContainer.appendChild(buttonSnappingContent);
        buttonSnapping.appendChild(buttonSnappingContainer);

        /**
         * Snapping Handle
         */
        const handleSnapping = function ()
        {
            // Set snapping button as active on menu
            $('#id-target-gpi-nb-snapping').toggleClass('hold-button');

            // Update snapping status
            myNetworkBudgetTool._mapSgs._snappingTool.update(!myNetworkBudgetTool._mapSgs._snappingTool._isActive);
        };
        buttonSnapping.addEventListener('click', handleSnapping, false);
        buttonSnapping.addEventListener('touchstart', handleSnapping, false);

        // -- Select edge -------------------------------------------------------------------------
        const buttonSelectElementToFill = document.createElement('li');
        buttonSelectElementToFill.className = "border-left";

        const buttonSelectElementToFillContainer = document.createElement('a');
        buttonSelectElementToFillContainer.setAttribute('href', '#id-target-gpi-nb-select-element-to-fill');
        buttonSelectElementToFillContainer.id = 'id-target-gpi-nb-select-element-to-fill';
        buttonSelectElementToFillContainer.className = 'target';
        buttonSelectElementToFillContainer.setAttribute('title', 'Selecionar para caracterizar rede');

        const buttonSelectElementToFillContent = document.createElement('div');
        buttonSelectElementToFillContent.className = 'menu-icon';
        buttonSelectElementToFillContent.setAttribute("style", "top: 18px");
        buttonSelectElementToFillContent.innerHTML = '<i class="material-icons">select_all</i>';

        buttonSelectElementToFillContainer.appendChild(buttonSelectElementToFillContent);
        buttonSelectElementToFill.appendChild(buttonSelectElementToFillContainer);

        /**
         * Select Handle
         */
        const handleSelectElementToFill = function () {
            if(myNetworkBudgetTool._buttonActive !== null && myNetworkBudgetTool._buttonActive !== "buttonSelectElementToFill")
                return;

            myNetworkBudgetTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-select-element-to-fill');

            if (!$(this).find('a').hasClass('hold-button')) { // Reset select

                // Active event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.on('singleclick', async (e) => { await myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips(e); });

                // Desactive select element
                myNetworkBudgetTool._selectElement.setActive(true);

                // Reset cursor
                document.body.style.cursor = 'default';

                // Free active button
                myNetworkBudgetTool._buttonActive = null;
            }
            else { // Active select
                // Remove event layer tooltips
                if(myNetworkBudgetTool._mapSgs.tooltips)
                    myNetworkBudgetTool._mapSgs.map.un('singleclick', myNetworkBudgetTool._mapSgs.tooltips.BuildInfoTooltips);

                // Active select element
                myNetworkBudgetTool._selectElement.setActive(true);

                // Change cursor
                document.body.style.cursor = 'pointer';

                // Get active button
                myNetworkBudgetTool._buttonActive = "buttonSelectElementToFill";
            }
        };

        buttonSelectElementToFill.addEventListener('click', handleSelectElementToFill, false);
        buttonSelectElementToFill.addEventListener('touchstart', handleSelectElementToFill, false);

        // -- Submit --------------------------------------------------------------------------
        const buttonSubmit = document.createElement('li');

        const buttonSubmitContainer = document.createElement('a');
        buttonSubmitContainer.setAttribute('title', 'Calcular orçamento');
        buttonSubmitContainer.setAttribute('href', '\\images\\Orcamentacao.xlsx');

        const buttonSubmitContent = document.createElement('div');
        buttonSubmitContent.className = 'menu-icon refresh';
        buttonSubmitContent.innerHTML = '<i class="fa fa-check modal-location-plant-button"></i>';

        buttonSubmitContainer.appendChild(buttonSubmitContent);
        buttonSubmit.appendChild(buttonSubmitContainer);

        /**
         * Submit handle location plant
         */
        const handleSubmit = function ()
        {
            
        };

        buttonSubmit.addEventListener('click', handleSubmit, false);
        buttonSubmit.addEventListener('touchstart', handleSubmit, false);

        // -- Close ---------------------------------------------------------------------------
        const buttonClose = document.createElement('li');

        const buttonCloseContainer = document.createElement('a');
        buttonCloseContainer.setAttribute('title', 'Fechar orçamentação');

        const buttonCloseContent = document.createElement('div');
        buttonCloseContent.className = 'menu-icon refresh';
        buttonCloseContent.innerHTML = '<i class="fa fa-times modal-location-plant-button"></i>';

        buttonCloseContainer.appendChild(buttonCloseContent);
        buttonClose.appendChild(buttonCloseContainer);

        /**
         * close handle
         */
        const handleClose = function ()
        {
            // Clean Budget
            myNetworkBudgetTool._CleanBudget();

            // Desactive all button
            myNetworkBudgetTool._DesactiveAllActiveButton();

            // Close Toolbar
            $('#id-menubar-bottom-network-budget-tool').toggle('ol-hidden');
        };

        buttonClose.addEventListener('click', handleClose, false);
        buttonClose.addEventListener('touchstart', handleClose, false);

        // -----------------------------------------------------------------------------------------
        // -- Build Menu ---------------------------------------------------------------------------
        // -----------------------------------------------------------------------------------------

        // -- Main menu bar network Budget tool -------------------------------------------------
        const mainMenuNetworkBudgetTool = document.createElement('ul');
        mainMenuNetworkBudgetTool.id = 'main-menu-network-budget-tool';
        mainMenuNetworkBudgetTool.className = 'map-controls menubar-bottom';

        mainMenuNetworkBudgetTool.appendChild(buttonSelect);

        mainMenuNetworkBudgetTool.appendChild(buttonDrawPipe);
        mainMenuNetworkBudgetTool.appendChild(buttonDrawManhole);
        
        mainMenuNetworkBudgetTool.appendChild(buttonClean);
        mainMenuNetworkBudgetTool.appendChild(buttonSnapping);
        
        mainMenuNetworkBudgetTool.appendChild(buttonSelectElementToFill);
        mainMenuNetworkBudgetTool.appendChild(buttonSubmit);
        mainMenuNetworkBudgetTool.appendChild(buttonClose);

        // -- Menu panel network Budget tool --------------------------------------------------
        const menuPanelNetworkBudgetTool = document.createElement('div');
        menuPanelNetworkBudgetTool.appendChild(mainMenuNetworkBudgetTool);

        return menuPanelNetworkBudgetTool;
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Execute budget report
     */
    this._ExecuteBudgetReport = function()
    {
        $('#id-modal-network-budget-report').show();
    }

    /**
     * Get all reference
     */
    this._GetAllReference = function()
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/NetworkBudgetTool/GetReference',
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção de referência para a orçamentação");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // ref_manhole_cover_type
                            myNetworkBudgetTool._referenceInfo["ref_manhole_cover_type"] = data.result.listCoverType;
                            myNetworkBudgetTool._utility.FillSelect('id-modal-network-budget-manhole-cover-type', data.result.listCoverType, "description", "id", true);

                            // ref_manhole_conical_trunk_type
                            myNetworkBudgetTool._referenceInfo["ref_manhole_conical_trunk_type"] = data.result.listConicalTrunkType;
                            myNetworkBudgetTool._utility.FillSelect('id-modal-network-budget-manhole-conical-trunk-type', data.result.listConicalTrunkType, "description", "id", true);

                            // ref_manhole_ring_type
                            myNetworkBudgetTool._referenceInfo["ref_manhole_ring_type"] = data.result.listRingType;
                            myNetworkBudgetTool._utility.FillSelect('id-modal-network-budget-manhole-ring-type', data.result.listRingType, "description", "id", true);

                            // ref_pipe_type
                            myNetworkBudgetTool._referenceInfo["ref_pipe_type"] = data.result.listRingType;
                            myNetworkBudgetTool._utility.FillSelect('id-modal-network-budget-pipe-type', data.result.listPipeType, "description", "id", true);

                            // ref_soil_type
                            myNetworkBudgetTool._referenceInfo["ref_soil_type"] = data.result.listSoilType;
                            myNetworkBudgetTool._utility.FillSelect('id-modal-network-budget-pipe-soil-type', data.result.listSoilType, "description", "id", true);

                            break;
                        default:
                            toastr["error"]("Erro na obtenção de referência para a orçamentação");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção de referência para a orçamentação");
            }
        });
    }

    /**
     * Clean budget
     */
    this._CleanBudget = function()
    {
        // Clear layer draw pipe
        myNetworkBudgetTool._layerDrawPipe.getSource().clear();

        // Clear layer draw manhole
        myNetworkBudgetTool._layerDrawManhole.getSource().clear();

        // Reset id feature generator
        myNetworkBudgetTool._idFeatureGenerator = 1;

        // Reset network budget info
        this._networkBugdetInfo = {
            pipe: {},
            manhole: {}
        };
    }

    /**
     * Clean bugdet form pipe
     */
    this._CleanBudgetFormPipe = function()
    {
        $('#id-modal-network-budget-pipe-id-feature').val("");
        $('#id-modal-network-budget-pipe-length').val("");
        $('#id-modal-network-budget-pipe-type').val("");
        $('#id-modal-network-budget-pipe-type').selectpicker("refresh");
        $('#id-modal-network-budget-pipe-soil-type').val("");
        $('#id-modal-network-budget-pipe-soil-type').selectpicker("refresh");
        
    }

    /**
     * Clean bugdet form manhole
     */
    this._CleanBudgetFormManhole = function()
    {
        $('#id-modal-network-budget-manhole-id-feature').val("");
        $('#id-modal-network-budget-manhole-depth').val("");
        $('#id-modal-network-budget-manhole-cover-type').val("");
        $('#id-modal-network-budget-manhole-cover-type').selectpicker("refresh");
        $('#id-modal-network-budget-manhole-conical-trunk-type').val("");
        $('#id-modal-network-budget-manhole-conical-trunk-type').selectpicker("refresh");
        $('#id-modal-network-budget-manhole-ring-type').val("");
        $('#id-modal-network-budget-manhole-ring-type').selectpicker("refresh");
    }

    /**
     * Desactive all active button budget
     */
    this._DesactiveAllActiveButton = function()
    {
        // Select button
        if ($('#id-target-gpi-nb-select-element').hasClass('hold-button')) {
            myNetworkSimulationTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-select-element');
        
            // Desactice interraction draw pipe modify
            myNetworkBudgetTool._modifyDrawPipe.setActive(false);

            // Desactice interraction draw manhole modify
            myNetworkBudgetTool._modifyDrawManhole.setActive(false);
        }

        // Draw pipe button
        if ($('#id-target-gpi-nb-draw-pipe').hasClass('hold-button')) {
            myNetworkSimulationTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-draw-pipe');
        
            // Desactive draw
            myNetworkBudgetTool._drawPipe.setActive(false);
        }

        // Draw manhole button
        if ($('#id-target-gpi-nb-draw-manhole').hasClass('hold-button')) {
            myNetworkSimulationTool._mapSgs._utility.HoldButtonEffect('main-menu-network-budget-tool', 'id-target-gpi-nb-draw-manhole');
        
            // Desactive draw
            myNetworkBudgetTool._drawManhole.setActive(false);
        }

        // Snapping
        if($('#id-target-gpi-nb-snapping').hasClass('hold-button'))
        {
            $('#id-target-gpi-nb-snapping').toggleClass('hold-button')

            // Update snapping status
            myNetworkBudgetTool._mapSgs._snappingTool.update(!myNetworkBudgetTool._mapSgs._snappingTool._isActive);
        }
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Event close modal budget pipe
     */
    $('#id-modal-network-budget-pipe-close').on('click', function() {
        $('#id-modal-network-budget-pipe').hide();
    });

    /**
     * Event close modal budget pipe
     */
    $('#id-modal-network-budget-manhole-close').on('click', function() {
        $('#id-modal-network-budget-manhole').hide();
    });

    /**
     * Event save pipe budget info
     */
    $('#id-modal-network-budget-pipe-submit').on('click', function()
    {
        var idFeature = $('#id-modal-network-budget-pipe-id-feature').val();
        myNetworkBudgetTool._networkBugdetInfo.pipe[idFeature] = 
        {
            length: $('#id-modal-network-budget-pipe-length').val(),
            id_pipe_type:  $('#id-modal-network-budget-pipe-type').val(),
            id_soil_type: $('#id-modal-network-budget-pipe-soil-type').val()
        };
        $('#id-modal-network-budget-pipe').hide();
    });

    /**
     * Event save manhole budget info
     */
    $('#id-modal-network-budget-manhole-submit').on('click', function()
    {
        var idFeature = $('#id-modal-network-budget-manhole-id-feature').val();
        myNetworkBudgetTool._networkBugdetInfo.manhole[idFeature] = 
        {
            depth:  $('#id-modal-network-budget-manhole-depth').val(),
            id_cover_type:  $('#id-modal-network-budget-manhole-cover-type').val(),
            id_conical_trunk_type: $('#id-modal-network-budget-manhole-conical-trunk-type').val(),
            id_ring_type: $('#id-modal-network-budget-manhole-ring-type').val()
        };
        $('#id-modal-network-budget-manhole').hide();
    });

    /**
     * Event close budget report
     */
    $('#id-modal-network-budget-report-close').on('click', function() {
        $('#id-modal-network-budget-report').hide();
    });

    // -- end event -------------------------------------------------------------------------------
}


/**
 * Init network buget tool
 * @param {object} mapSgs, map object
 */
NetworkBudgetTool.prototype.Init = function (mapSgs)
{
    if (!this._toolInitialize)
    {
        this._toolInitialize = true;

        var this_ = this;

        // Set map info
        this._mapSgs = mapSgs;

        // -- Get all reference -------------------------------------------------------------------
        this._GetAllReference();

        // -- Draw pipe ---------------------------------------------------------------------------

        // Layer draw pipe
        this._layerDrawPipe = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleDrawPipe,
            name: 'draw_pipe'
        });
        this._mapSgs.map.addLayer(this._layerDrawPipe);

        // Layer draw pipe - event on add feature
        this._layerDrawPipe.getSource().on('addfeature', function (evt)
        {
            // Set info to feature
            evt.feature.set('name', 'pipe');
            evt.feature.setId(this_._idFeatureGenerator);
            this_._idFeatureGenerator++;

            // Add feature for snapping
            this_._mapSgs._snappingTool.snap.addFeature(evt.feature);
        });

        // Modify layer draw pipe
        this._modifyDrawPipe = new Modify({
            source: this._layerDrawPipe.getSource()
        });
        this._mapSgs.map.addInteraction(this._modifyDrawPipe);
        this._modifyDrawPipe.setActive(false);

        // Draw pipe
        this._drawPipe = new Draw({
            source: this._layerDrawPipe.getSource(),
            type: 'LineString',
            style: this._styleDrawPipe,
            condition: function (evt) {
                return true;
            },
            finishCondition: function (evt) {
                return true;
            }
        });
        this._drawPipe.setActive(false);
        this._mapSgs.map.addInteraction(this._drawPipe);

        // -- Draw manhole ------------------------------------------------------------------------

        // Layer draw manhole
        this._layerDrawManhole = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleDrawManhole,
            name: 'draw_pipe'
        });
        this._mapSgs.map.addLayer(this._layerDrawManhole);

        // Layer draw manhole - event on add feature
        this._layerDrawManhole.getSource().on('addfeature', function (evt)
        {
            // Set info to feature
            evt.feature.set('name', 'manhole');
            evt.feature.setId(this_._idFeatureGenerator);
            this_._idFeatureGenerator++;

            // Add feature for snapping
            this_._mapSgs._snappingTool.snap.addFeature(evt.feature);
        });

        // Modify layer draw manhole
        this._modifyDrawManhole = new Modify({
            source: this._layerDrawManhole.getSource()
        });
        this._mapSgs.map.addInteraction(this._modifyDrawManhole);
        this._modifyDrawManhole.setActive(false);

        // Draw pipe
        this._drawManhole = new Draw({
            source: this._layerDrawManhole.getSource(),
            type: 'Point',
            style: this._styleDrawManhole,
            condition: function (evt) {
                return true;
            },
            finishCondition: function (evt) {
                return true;
            }
        });
        this._drawManhole.setActive(false);
        this._mapSgs.map.addInteraction(this._drawManhole);

        // -- Select element ----------------------------------------------------------------------

        // Select element interaction
        this._selectElement = new Select({
            condition: click,
            layers: [this._layerDrawManhole, this._layerDrawPipe],
            wrapX: false,
            style: this._selectElementStyle
        });
        this._selectElement.setActive(false);
        this._mapSgs.map.addInteraction(this._selectElement);

        // Event on select
        this._selectElement.on('select', function (evt)
        {
            if(evt.selected.length > 0)
            {
                var feature = evt.selected[0];
                var nameFeature = feature.get('name');
                var idFeature = feature.getId();

                switch(nameFeature)
                {
                    case "pipe":
                        // Clean form pipe
                        this_._CleanBudgetFormPipe();

                        // Fill id feature
                        $('#id-modal-network-budget-pipe-id-feature').val(idFeature);

                        // length
                        var length = Math.round(feature.getGeometry().getLength() * 100) / 100;
                        $('#id-modal-network-budget-pipe-length').val(length);

                        if(this_._networkBugdetInfo.pipe[idFeature])
                        {
                            if(this_._networkBugdetInfo.pipe[idFeature].id_pipe_type)
                            {
                                $('#id-modal-network-budget-pipe-type').val(this_._networkBugdetInfo.pipe[idFeature].id_pipe_type);
                                $('#id-modal-network-budget-pipe-type').selectpicker("refresh");
                            }
                            if(this_._networkBugdetInfo.pipe[idFeature].id_soil_type)
                            {
                                $('#id-modal-network-budget-pipe-soil-type').val(this_._networkBugdetInfo.pipe[idFeature].id_soil_type);
                                $('#id-modal-network-budget-pipe-soil-type').selectpicker("refresh");
                            }
                        }

                        // Show modal
                        $('#id-modal-network-budget-pipe').show();
                        break;
                    case "manhole":
                        // Clean form manhole
                        this_._CleanBudgetFormManhole();

                        // Fill id feature
                        $('#id-modal-network-budget-manhole-id-feature').val(idFeature);

                        if(this_._networkBugdetInfo.manhole[idFeature])
                        {
                            if(this_._networkBugdetInfo.manhole[idFeature].depth)
                                $('#id-modal-network-budget-manhole-depth').val(this_._networkBugdetInfo.manhole[idFeature].depth);
                            if(this_._networkBugdetInfo.manhole[idFeature].id_cover_type)
                            {
                                $('#id-modal-network-budget-manhole-cover-type').val(this_._networkBugdetInfo.manhole[idFeature].id_cover_type);
                                $('#id-modal-network-budget-manhole-cover-type').selectpicker("refresh");
                            }
                            if(this_._networkBugdetInfo.manhole[idFeature].id_conical_trunk_type)
                            {
                                $('#id-modal-network-budget-manhole-conical-trunk-type').val(this_._networkBugdetInfo.manhole[idFeature].id_conical_trunk_type);
                                $('#id-modal-network-budget-manhole-conical-trunk-type').selectpicker("refresh");
                            }
                            if(this_._networkBugdetInfo.manhole[idFeature].id_ring_type)
                            {
                                $('#id-modal-network-budget-manhole-ring-type').val(this_._networkBugdetInfo.manhole[idFeature].id_ring_type);
                                $('#id-modal-network-budget-manhole-ring-type').selectpicker("refresh");
                            }
                        }

                        // Show modal
                        $('#id-modal-network-budget-manhole').show();
                        break;
                    default:
                        // do nothing
                }
            }
        });
    }
}